import type { SpotType } from '~/lib/graphql/graphql'
import type { MinimumAreaCode, SmallAreaCode, SpotId } from '~/lib/graphql/scalars'

type Spot = {
  spotId: SpotId
  name: string
  type: SpotType
  minimumArea: {
    code: MinimumAreaCode
    parent: {
      code: SmallAreaCode
      parent: {
        key: string
      }
    }
  }
}

type Link = {
  canonicalPath: string
  anchorText: string
}

/** スポットのリストへのリンクを返す */
export function spotListLink(spot: Spot): Link {
  const canonicalPath = (() => {
    // PPG はすべてエリアページとして表示させる
    if (import.meta.env.VITE_MODE === 'ppg' || spot.type === 'HOTEL') {
      const {
        code: minimumAreaCode,
        parent: {
          code: smallAreaCode,
          parent: { key },
        },
      } = spot.minimumArea
      return `/area/${key}/${smallAreaCode}/${minimumAreaCode}/spot${spot.spotId}/`
    }
    return `/s-spot${spot.spotId}/`
  })()
  return {
    canonicalPath,
    anchorText: spot.name,
  }
}

if (import.meta.vitest) {
  const { describe, expect, test } = import.meta.vitest

  describe('spotListLink', () => {
    test('駅の場合', () => {
      const spot = {
        spotId: '88' as SpotId,
        name: '乃木坂駅',
        type: 'STATION' as const,
        minimumArea: {
          code: '0016' as MinimumAreaCode,
          parent: {
            code: '007' as SmallAreaCode,
            parent: {
              key: 'tokyo',
            },
          },
        },
      }

      if (import.meta.env.VITE_MODE === 'ppg') {
        expect(spotListLink(spot)).toEqual({
          anchorText: '乃木坂駅',
          canonicalPath: '/area/tokyo/007/0016/spot88/',
        })
      } else {
        expect(spotListLink(spot)).toEqual({
          anchorText: '乃木坂駅',
          canonicalPath: '/s-spot88/',
        })
      }
    })

    test('ホテルの場合', () => {
      const spot = {
        spotId: '612' as SpotId,
        name: 'ザ・リッツ・カールトン東京',
        type: 'HOTEL' as const,
        minimumArea: {
          code: '0016' as MinimumAreaCode,
          parent: {
            code: '007' as SmallAreaCode,
            parent: {
              key: 'tokyo',
            },
          },
        },
      }

      expect(spotListLink(spot)).toEqual({
        anchorText: 'ザ・リッツ・カールトン東京',
        canonicalPath: '/area/tokyo/007/0016/spot612/',
      })
    })

    test('ランドマークの場合', () => {
      const spot = {
        spotId: '2002' as SpotId,
        name: '東京ミッドタウン',
        type: 'LANDMARK' as const,
        minimumArea: {
          code: '0016' as MinimumAreaCode,
          parent: {
            code: '007' as SmallAreaCode,
            parent: {
              key: 'tokyo',
            },
          },
        },
      }

      if (import.meta.env.VITE_MODE === 'ppg') {
        expect(spotListLink(spot)).toEqual({
          anchorText: '東京ミッドタウン',
          canonicalPath: '/area/tokyo/007/0016/spot2002/',
        })
      } else {
        expect(spotListLink(spot)).toEqual({
          anchorText: '東京ミッドタウン',
          canonicalPath: '/s-spot2002/',
        })
      }
    })
  })
}
